let _i = 0;
export const POSITIONS = {
  LEFT: _i++,
  RIGHT: _i++,
  TOP: _i++,
  BOTTOM: _i++,
  CENTER: _i++,
  COVER: _i++,
  NONE: _i++,
};
